import { OfferKindEnum } from '../../../../services/exports/Constants';

const offers: Record<OfferKindEnum & { from_to: string }, any> = {
  [OfferKindEnum.PercentageOffByProducts]: {
    title: 'Spar {{percentageAmount}}% på udvalgte varer',
    description:
      'Spar {{percentageAmount}}% på din ordre, når du bestiller udvalgte varer. Tilbuddet er gyldigt{{fromTo}}, indtil den maksimale grænse for kampagner er nået, alt efter hvad der indtræffer først. Kan ikke kombineres med andre tilbud.',
  },
  [OfferKindEnum.PercentageOffByMinSpendValue]: {
    title: '{{percentageAmount}}% rabat fra {{minSpendValue}}',
    description:
      'Spar {{percentageAmount}}% på din ordre. Tilbuddet er gyldigt{{fromTo}}, indtil den maksimale grænse for kampagner er nået, alt efter hvad der indtræffer først. Kan ikke kombineres med andre tilbud.',
  },
  [OfferKindEnum.AmountOffByProducts]: {
    title: 'Spar {{amount}} på udvalgte varer',
    description:
      'Spar {{amount}}, når du bestiller udvalgte varer. Tilbuddet er gyldigt{{fromTo}}, indtil den maksimale grænse for kampagner er nået, alt efter hvad der indtræffer først. Kan ikke kombineres med andre tilbud.',
  },
  [OfferKindEnum.AmountOffByMinSpendValue]: {
    title: 'Spar {{amount}} fra {{minSpendValue}}',
    description:
      'Spar {{amount}} ved en bestilling af denne værdi. Tilbuddet gælder{{fromTo}} indtil den maksimale grænse for kampagner er nået, alt efter hvad der indtræffer først. Kan ikke kombineres med andre kampagner.',
  },
  [OfferKindEnum.Bogo]: {
    title: 'Køb 2 til prisen for 1!',
    description:
      'Køb en vare og få den anden gratis. Tilbuddet gælder{{fromTo}} indtil kampagnegrænsen er nået, alt efter hvad der indtræffer først. Kan ikke kombineres med andre kampagner.',
  },
  [OfferKindEnum.BogoHalfPrice]: {
    title: 'Køb en, få en til halv pris!',
    description:
      'Køb en vare og få den anden til halv pris. Tilbuddet gælder{{fromTo}} indtil kampagnegrænsen er nået, alt efter hvad der indtræffer først. Kan ikke kombineres med andre kampagner.',
  },
  [OfferKindEnum.FreeItemByMinSpendValue]: {
    title: 'Gratis vare ved en bestilling af denne værdi',
    description:
      'Få en gratis vare, når du opfylder tilbuddets betingelser. Tilbuddet gælder{{fromTo}} indtil kampagnegrænsen er nået, alt efter hvad der indtræffer først. Kan ikke kombineres med andre kampagner.',
    reward_items_description: 'Vælg din gratis vare.',
  },
  [OfferKindEnum.FreeItemByProducts]: {
    title: 'Gratis vare med din bestilling',
    description:
      'Få en gratis vare, når du opfylder tilbuddets betingelser. Tilbuddet gælder{{fromTo}} indtil kampagnegrænsen er nået, alt efter hvad der indtræffer først. Kan ikke kombineres med andre kampagner.',
    qualifying_items_description: 'Vælg de varer, kunden skal bestille for at få den gratis vare.',
    reward_items_description: 'Vælg din gratis vare.',
  },
};

export default {
  offers,
  from_to: ' fra {{startsAt}} til {{endsAt}} eller',
  qualifying_items_title: 'Kvalificerende varer',
  reward_items_title: 'Gratis varer',
  buttons: {
    add: 'Læg i kurv',
  },
};
